<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M12 12.5C14.415 12.5 16.375 10.596 16.375 8.25C16.375 5.904 14.415 4 12 4C9.585 4 7.625 5.904 7.625 8.25C7.625 10.596 9.585 12.5 12 12.5ZM5 21C5 19.198 5.73499 17.4697 7.04749 16.189C8.35999 14.914 10.1392 14.2 12 14.2C13.8608 14.2 15.6342 14.914 16.9525 16.189C18.265 17.464 19 19.1923 19 21L5 21Z"
        :stroke="color"
        stroke-width="1.2"
        stroke-miterlimit="10"
      />
      <path
        d="M18.5074 3.94172C19.4895 3.37048 20.8685 3.62057 21.5875 4.50031C22.3065 5.38005 22.0932 6.5563 21.1111 7.12754C20.9402 7.22697 20.7572 7.30151 20.5678 7.35218C19.9801 7.5094 19.3861 7.86764 19.2798 8.45392L19.1835 8.98471M18.7984 11.1078L18.8038 11.1088L18.8028 11.1141L18.7974 11.1131L18.7984 11.1078Z"
        :stroke="color"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 24,
    color: "currentColor",
  },
);
</script>
